import React, { ReactNode } from "react";
import style from "./grid.module.scss";

interface Props {
  children: ReactNode;
}

const FormGrid = ({ children }: Props) => {
  return <div className={style.grid}>{children}</div>;
};

export default FormGrid;
